import { render, staticRenderFns } from "./FerramentaCalculadoraTijolo.vue?vue&type=template&id=28069322&scoped=true"
import script from "./FerramentaCalculadoraTijolo.vue?vue&type=script&lang=js"
export * from "./FerramentaCalculadoraTijolo.vue?vue&type=script&lang=js"
import style0 from "./FerramentaCalculadoraTijolo.vue?vue&type=style&index=0&id=28069322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28069322",
  null
  
)

export default component.exports